import React from "react";
import { TextField, InputAdornment, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  textFieldRoot: {
    width: 120,
    "& .MuiInputBase-root": {
      height: "35px",
      borderRadius: "20px",
      "& .prefix-icon-wrapper > .MuiSvgIcon-root": {
        color: "#3699FF",
      },
    },
  },
}));

export default (props) => {
  const { placeholder, prefixIcon, value, setValue } = props;
  const classes = useStyles();
  return (
    <TextField
      placeholder={placeholder}
      variant="outlined"
      classes={{ root: classes.textFieldRoot }}
      InputProps={{
        startAdornment: (
          <InputAdornment className="prefix-icon-wrapper" position="start">
            {prefixIcon}
          </InputAdornment>
        ),
      }}
      value={value}
      type="number"
      onChange={(e) => {
        console.log(typeof e.target.value);
        setValue(e.target.value);
      }}
    ></TextField>
  );
};
